import React from 'react';
import { Route } from 'react-router-dom';
import { AdminRoute } from '@/features/admin/components/AdminRoute';
import { AdminLayout } from '@/features/admin/layouts/AdminLayout';
import { lazyPage, RouteFallback } from './lazy';

const AdminDashboardPage = lazyPage(
  () => import('@/features/admin/pages/AdminDashboardPage'),
  'AdminDashboardPage'
);
const AdminUsersPage = lazyPage(
  () => import('@/features/admin/pages/AdminUsersPage'),
  'AdminUsersPage'
);
const AdminUserDetailPage = lazyPage(
  () => import('@/features/admin/pages/AdminUserDetailPage'),
  'AdminUserDetailPage'
);
const AdminOrgsPage = lazyPage(
  () => import('@/features/admin/pages/AdminOrgsPage'),
  'AdminOrgsPage'
);
const AdminPendingOrgsPage = lazyPage(
  () => import('@/features/admin/pages/AdminPendingOrgsPage'),
  'AdminPendingOrgsPage'
);
const AdminJobsPage = lazyPage(
  () => import('@/features/admin/pages/AdminJobsPage'),
  'AdminJobsPage'
);
const AdminAssessmentsPage = lazyPage(
  () => import('@/features/admin/pages/AdminAssessmentsPage'),
  'AdminAssessmentsPage'
);
const AdminAssessmentBuilderPage = lazyPage(
  () => import('@/features/admin/pages/AdminAssessmentBuilderPage'),
  'AdminAssessmentBuilderPage'
);
const AdminOrgAssessmentsPage = lazyPage(
  () => import('@/features/admin/pages/AdminOrgAssessmentsPage'),
  'AdminOrgAssessmentsPage'
);
const AdminOrgAssessmentDetailPage = lazyPage(
  () => import('@/features/admin/pages/AdminOrgAssessmentDetailPage'),
  'AdminOrgAssessmentDetailPage'
);
const AdminCreditsPage = lazyPage(
  () => import('@/features/admin/pages/AdminCreditsPage'),
  'AdminCreditsPage'
);
const AdminFeatureFlagsPage = lazyPage(
  () => import('@/features/admin/pages/AdminFeatureFlagsPage'),
  'AdminFeatureFlagsPage'
);
const AdminTeamPage = lazyPage(
  () => import('@/features/admin/pages/AdminTeamPage'),
  'AdminTeamPage'
);
const AdminActivityPage = lazyPage(
  () => import('@/features/admin/pages/AdminActivityPage'),
  'AdminActivityPage'
);
const AdminLocationSuggestionsPage = lazyPage(
  () => import('@/features/admin/pages/AdminLocationSuggestionsPage'),
  'AdminLocationSuggestionsPage'
);
const AdminSkillSuggestionsPage = lazyPage(
  () => import('@/features/admin/pages/AdminSkillSuggestionsPage'),
  'AdminSkillSuggestionsPage'
);
const AdminBillingSubscriptionsPage = lazyPage(
  () => import('@/features/admin/pages/AdminBillingSubscriptionsPage'),
  'AdminBillingSubscriptionsPage'
);
const AdminBillingInvoicesPage = lazyPage(
  () => import('@/features/admin/pages/AdminBillingInvoicesPage'),
  'AdminBillingInvoicesPage'
);
const AdminBillingDunningPage = lazyPage(
  () => import('@/features/admin/pages/AdminBillingDunningPage'),
  'AdminBillingDunningPage'
);
const AdminBillingEntitlementsPage = lazyPage(
  () => import('@/features/admin/pages/AdminBillingEntitlementsPage'),
  'AdminBillingEntitlementsPage'
);
const AdminBillingReportsPage = lazyPage(
  () => import('@/features/admin/pages/AdminBillingReportsPage'),
  'AdminBillingReportsPage'
);
const AdminLocationBulkUploadPage = lazyPage(
  () => import('@/features/admin/pages/AdminLocationBulkUploadPage'),
  'AdminLocationBulkUploadPage'
);
const MasterDataListPage = lazyPage(
  () => import('@/features/admin/pages/MasterDataListPage'),
  'MasterDataListPage'
);

const HandbookPage = lazyPage(
  () => import('@/features/handbook/pages/HandbookPage'),
  'HandbookPage'
);

export const AdminRoutes = () => (
  <>
    {/* Platform Handbook: admin-only, but its own full-screen docs layout. */}
    <Route
      path="/admin/handbook/*"
      element={
        <AdminRoute>
          <React.Suspense fallback={<RouteFallback />}>
            <HandbookPage />
          </React.Suspense>
        </AdminRoute>
      }
    />
    <Route
      path="/admin"
      element={
        <AdminRoute>
          <AdminLayout />
        </AdminRoute>
      }
    >
      <Route index element={<AdminDashboardPage />} />
      <Route path="users" element={<AdminUsersPage />} />
      <Route path="users/:id" element={<AdminUserDetailPage />} />
      <Route path="organizations" element={<AdminOrgsPage />} />
      <Route path="organizations/pending" element={<AdminPendingOrgsPage />} />
      <Route path="jobs" element={<AdminJobsPage />} />
      <Route path="assessments" element={<AdminAssessmentsPage />} />
      <Route path="assessments/new" element={<AdminAssessmentBuilderPage />} />
      <Route path="assessments/oversight" element={<AdminOrgAssessmentsPage />} />
      <Route path="assessments/oversight/:id" element={<AdminOrgAssessmentDetailPage />} />
      <Route path="assessments/:id" element={<AdminAssessmentBuilderPage />} />
      <Route path="credits" element={<AdminCreditsPage />} />
      <Route path="billing" element={<AdminBillingSubscriptionsPage />} />
      <Route path="billing/subscriptions" element={<AdminBillingSubscriptionsPage />} />
      <Route path="billing/invoices" element={<AdminBillingInvoicesPage />} />
      <Route path="billing/dunning" element={<AdminBillingDunningPage />} />
      <Route path="billing/entitlements" element={<AdminBillingEntitlementsPage />} />
      <Route path="billing/reports" element={<AdminBillingReportsPage />} />
      <Route path="flags" element={<AdminFeatureFlagsPage />} />
      <Route path="team" element={<AdminTeamPage />} />
      <Route path="activity" element={<AdminActivityPage />} />
      <Route path="locations/suggestions" element={<AdminLocationSuggestionsPage />} />
      <Route path="skills/suggestions" element={<AdminSkillSuggestionsPage />} />
      <Route path="locations/bulk" element={<AdminLocationBulkUploadPage />} />
      <Route path="master-data/:entitySlug" element={<MasterDataListPage />} />
    </Route>
  </>
);
